// http(s) only: author- or portal-user-supplied URLs (event_url, InventMe media and
// attachments) must never render another scheme (javascript:, data:, ...) as a link in
// an admin session. Returns the normalised href, or null.
export function safeHttpUrl(value) {
  if (typeof value !== "string") return null;
  try {
    const u = new URL(value);
    return u.protocol === "http:" || u.protocol === "https:" ? u.href : null;
  } catch (_) {
    return null;
  }
}
